import {DecimalPipe} from '@angular/common'
import {Component, effect, inject} from '@angular/core'
import {HemnetService} from '../../services/hemnet.service'

@Component({
  selector: 'spb-object-info',
  templateUrl: './object-info.component.html',
  styleUrls: ['./object-info.component.scss'],
  imports: [DecimalPipe]
})
export class ObjectInfoComponent {
  public imageUrl = 'assets/no-thumb.png'

  public name = 'Ingen adress 1a'

  public askingPrice = 0

  public area = 0

  public year = 2000

  public fee = 0

  private readonly hemnetService = inject(HemnetService)

  constructor() {
    effect(() => {
      const hemnetData = this.hemnetService.hemnetData()
      this.imageUrl = hemnetData.image || 'assets/no-thumb.svg'
      this.year = hemnetData.year
      this.area = hemnetData.area
      this.fee = hemnetData.fee
      this.askingPrice = hemnetData.askingPrice
      this.name = hemnetData.name
    })
  }
}
